import { GrowthBook } from "@growthbook/growthbook-react";

export const GROWTHBOOK_CLIENT_OPTIONS = {
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-vWzoYlSke6Oc4ucY",
  enableDevMode: true,
};

const placeholderGrowthBookRef = { current: null };

export function createGrowthBook(options = {}) {
  return new GrowthBook({
    ...GROWTHBOOK_CLIENT_OPTIONS,
    ...options,
  });
}

export function getPlaceholderGrowthBook() {
  if (!placeholderGrowthBookRef.current) {
    placeholderGrowthBookRef.current = createGrowthBook();
  }

  return placeholderGrowthBookRef.current;
}
